/**
 * Academy domain — `AcademyMeteringStore` state shape. Remote-only, in-memory.
 * `usageByPeriod` caches the per-period usage metrics keyed by the `YYYY-MM` period.
 */
import type { UsageMetricResponse } from './academy.model';

export interface AcademyMeteringState {
  /** Usage metrics indexed by period key (`YYYY-MM`). */
  usageByPeriod: Record<string, UsageMetricResponse[]>;
  /**
   * The period window currently scanned by the screen (ascending `YYYY-MM` keys). Remembered
   * so that `aggregate`/`close` can re-read the same window after a successful command without
   * the caller threading it back through.
   */
  window: string[];
}

export const initialAcademyMeteringState: AcademyMeteringState = {
  usageByPeriod: {},
  window: [],
};
